import Backbone from 'backbone'
import Parse from 'parse'
import ObservingSession from '../helpers/ObservingSession'
import BaseParseObject from './BaseParseObject'

'use strict'

export const ObservingSite = BaseParseObject.extend('ObservingSite', {

  update: function (data) {
    const acl = new Parse.ACL()

    if (!this.get('ACL')) {
      acl.setPublicReadAccess(false)
      acl.setReadAccess(Parse.User.current().id, true)
      acl.setWriteAccess(Parse.User.current().id, true)
      this.setACL(acl)
    }

    // create a geopoint for the location
    const point = new Parse.GeoPoint({
      latitude: parseFloat(data.latitude),
      longitude: parseFloat(data.longitude)
    })

    // set the object attributes
    this.set('user', Parse.User.current())
    this.set('name', data.name)
    this.set('location', point)
    this.set('elevation', parseFloat(data.elevation))
    this.set('timezone', parseFloat((data.timezone)))

    // save the object
    return this.save().then(
      (item) => {
        // The save was successful.
        Backbone.trigger('observingSites:updated', item)
      },
      (error) => {
         // The save failed.  Error is an instance of Parse.Error.
         Backbone.trigger('errors:parseReturned', error)
      }
    )
  },

  delete: function () {
    const observingSessions = ObservingSession.getObservingSessionsBySite(this)

    if (Array.isArray(observingSessions) && observingSessions.length > 0) {
      let message = `Cannot delete this Site because it is still referenced by ${observingSessions.length} session`

      if (observingSessions.length > 1) {
        message += 's'
      }

      Backbone.trigger('errors:deleteNotAllowed', 'Site', message)

      return Promise.reject(new Error(message))
    }

    this.set('deleted', true)

    return this.save().then(
      (result) => {
        Backbone.trigger('observingSite:deleted', result)
    },
      (error) => {
        Backbone.trigger('errors:parseReturned', error)
    })
  }

})

export default ObservingSite
